import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { ErrorMessage } from 'components/Widgets/ErrorMessage';
import { useAPIData } from 'hooks/useAPIData';
import { UniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import useDataRefresh from 'hooks/useDataRefresh';
import { Accordion } from 'react-bootstrap';
import { getAirportDelays } from 'services/weather/airports.service';

let dataCache = { airportDelays: null };

export const AirportDelay = ({ widget, dimensions }) => {
  const [error, setError] = useState({ state: false, message: '' });
  const [fetching, setFetching] = useState(true);

  const FusionData = useAPIData({
    successCallback: () => {
      setFetching(false);
    },
    errorCallback: () => {
      setError({ state: true, message: 'Error fetching data' });
      setFetching(false);
    },
    fetchingCallback: () => {
      setFetching(true);
    },
  });

  const [airportDelays, setAirportDelays] = useState([]);

  const uwf = useContext(UniqueWidgetRefreshContext);
  const ROUTE = 'getAirportDelays';
  const LOCATION = Cookies.get('city') + '-' + Cookies.get('state');
  const UNIQUEKEY = LOCATION + '-' + ROUTE;

  useEffect(() => {
    const fetchData = async () => {
      try {
        FusionData.forceGet({ key: ROUTE, apiFunction: getAirportDelays }).then((res) => {
          dataCache.airportDelays = res.data.result;
          setAirportDelays(dataCache.airportDelays);

          setFetching(false);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [uwf[UNIQUEKEY]]);
  const dataRefresh = useDataRefresh();
  useEffect(() => {
    dataCache = { airportDelays: null };
    setFetching(true);
  }, [dataRefresh.widgetRefresh]);

  useEffect(() => {
    (async () => {
      //get airportDelays data
      if (!dataCache.airportDelays) {
        FusionData.get({ key: ROUTE, apiFunction: getAirportDelays })
          .then((res) => {
            dataCache.airportDelays = res.data.result;
            setAirportDelays(dataCache.airportDelays);

            setFetching(false);
          })
          .catch((err) => {
            setError({ state: true, message: err.message });
          });
      } else {
        setAirportDelays(dataCache.airportDelays);
        setFetching(false);
      }
    })();
  }, [dataRefresh.widgetRefresh]);

  const groupSegmentsByDay = (segments) => {
    let groupedSegments = {};
    segments.forEach((segment) => {
      if (segment.iso8601.split('T')[1].includes('00:00:00')) {
        let date = new Date(segment.iso8601.split('T')[0]);
        date.setDate(date.getDate() - 1);
        segment.iso8601 = date.toISOString();
      }
      let day = segment.iso8601.split('T')[0];
      if (!groupedSegments[day]) {
        groupedSegments[day] = [];
      }
      groupedSegments[day].push(segment);
    });
    return groupedSegments;
  };

  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  if (fetching && widget) {
    // if (true && widget) {
    return <WidgetLoadingAnimation widgetName={'AirportDelay'} dimensions={dimensions} />;
  }

  if (fetching) {
    return <WidgetLoadingAnimation />;
  }

  if (airportDelays && airportDelays.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} updateIntervalMinutes={60} />
        <div className="p-3">No data found.</div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column h-100">
      <WidgetTimeUpdate route={ROUTE} updateIntervalMinutes={60} />
      <Accordion alwaysOpen className="mx-1 align-items-center overflow-scroll">
        {airportDelays.map((delays, index) => {
          return (
            <Accordion.Item key={index} eventKey={index} className="mt-3 bg-primary">
              <Accordion.Header className="rounded-2 bg-primary">
                <div className="d-flex w-100 h4 my-auto me-3 justify-content-between">
                  <div className="">{delays.location || 'None found'}</div>
                  <div> {moment(new Date()).format('MM/DD/YYYY')}</div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="w-100">
                  {airportDelays.length > 0 &&
                    airportDelays[0].segments &&
                    Object.entries(groupSegmentsByDay(JSON.parse(delays.segments))).map(
                      ([day, segments], index) => {
                        return (
                          // map each days segments to morning, afternoon, evening, and night
                          <div key={index} className="d-flex flex-column justify-content-between">
                            <div className="fw-bold h4 mb-2 border-bottom border-1 border-light-subtle">
                              {new Date(
                                new Date(segments[0].iso8601).getTime() - 60000,
                              ).toLocaleDateString('en-US')}
                            </div>
                            <div className="d-flex flex-row justify-content-between flex-wrap">
                              {segments.map((item, index) => {
                                return (
                                  <div className="d-flex flex-column w-50 mb-5" key={index}>
                                    <h2 className="border-botom border-1 border-light-subtle mb-2">
                                      {item.day_segment}
                                    </h2>
                                    {item.delay_time !== '0' ? (
                                      <div className="gap-2 d-flex flex-column">
                                        {/* {item.delay_time && <div>Delay Time: {item.delay_time}</div>} */}
                                        {item.delay && <div>Delay: {item.delay}</div>}
                                        {/* {item.primary_delay_reason && <div>Primary Delay Reason: {item.primary_delay_reason}</div>} */}
                                        {item.primary_reason && (
                                          <div className="">
                                            Primary Reason: {item.primary_reason}
                                          </div>
                                        )}
                                        {/* {item.secondary_delay_reason && <div>Secondary Delay Reason: {item.secondary_delay_reason}</div>} */}
                                        {item.secondary_reason && (
                                          <div className="">
                                            Secondary Reason: {item.secondary_reason}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div className=""> No delays</div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      },
                    )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

